import imageMimeTypes from "../lib/supported_image_mime_types"

$(document).on("change", ".avatar-upload input[type='file']", function () {
  let $img = $(this).parents(".avatar-upload").find("img.member-avatar")

  let $hint = $(this).parents(".avatar-upload").find(".help-block")

  const hintText = $hint.data("text-hint")
  const errorHintText = $hint.data("text-hint-error")

  let reader = new FileReader()
  reader.onload = function (e) {
    const dataURL = e.target.result
    const mimeType = dataURL.split(",")[0].split(":")[1].split(";")[0]

    if (imageMimeTypes.includes(mimeType)) {
      $img.replaceWith(
        $("<img />", {
          src: dataURL,
          class: "member-avatar preview",
        })
      )
      $hint.html(hintText)
      $hint.removeClass("text-danger-600 dark:text-danger-400")
    } else {
      $hint.html(errorHintText)
      $hint.addClass("text-danger-600 dark:text-danger-400")
      $(this).val(null)
    }
  }
  reader.readAsDataURL($(this)[0].files[0])
})
